module.exports = __webpack_public_path__ + "img/title1.27170e5b.png";